import React from 'react';
import PropTypes from 'prop-types';
import Breadcrumb from '../../../../core/layout/Breadcrumb';

const CertificationTestItemHistoryBreadcrumbs = (props) => (
  <Breadcrumb
    fetching={props.fetching}
    crumbs={[
      {
        text: 'Certification Tests',
        link: '/certification-test-register',
      },
      {
        text: 'Certification Test Items',
        link: `/certification-test-register/${props.certificationTestItem.certificationTestCourseAbility.id}`,
      },
      {
        text: 'History',
      },
    ]}
  />
);

CertificationTestItemHistoryBreadcrumbs.propTypes = {
  fetching: PropTypes.bool,
  certificationTestItem: PropTypes.shape({
    certificationTestCourseAbility: PropTypes.shape({
      id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

CertificationTestItemHistoryBreadcrumbs.defaultProps = {
  fetching: false,
};

export default CertificationTestItemHistoryBreadcrumbs;
